var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExcel01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECEFF1;}\n\t.st1{fill:#388E3C;}\n\t.st2{fill:#2E7D32;}\n\t.st3{fill:#FAFAFA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2646",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1255",
    className: "st0",
    d: "M34.3,30H19.1c-0.6,0-1.1-0.5-1.1-1.1V7.1C18,6.5,18.5,6,19.1,6l0,0h15.2 c0.6,0,1.1,0.5,1.1,1.1v21.8C35.4,29.5,34.9,30,34.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1256",
    className: "st1",
    d: "M23.4,12.6h-4.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1.1h4.4c0.6,0,1.1,0.5,1.1,1.1 C24.5,12.1,24,12.5,23.4,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1257",
    className: "st1",
    d: "M23.4,16.9h-4.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1.1h4.4c0.6,0,1.1,0.5,1.1,1.1 C24.5,16.4,24,16.9,23.4,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1258",
    className: "st1",
    d: "M23.4,21.3h-4.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1.1h4.4c0.6,0,1.1,0.5,1.1,1.1 C24.5,20.8,24,21.3,23.4,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1259",
    className: "st1",
    d: "M23.4,25.6h-4.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1.1h4.4c0.6,0,1.1,0.5,1.1,1.1 C24.5,25.1,24,25.6,23.4,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1260",
    className: "st1",
    d: "M30,12.6h-2.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0.1,0H30 c0.6,0,1.1,0.5,1.1,1.1C31.1,12,30.6,12.5,30,12.6C30,12.6,30,12.6,30,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1261",
    className: "st1",
    d: "M30,16.9h-2.2c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1c0,0,0,0,0.1,0H30 c0.6,0,1.1,0.5,1.1,1.1C31.1,16.4,30.6,16.9,30,16.9C30,16.9,30,16.9,30,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1262",
    className: "st1",
    d: "M30,21.3h-2.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0.1,0H30 c0.6,0,1.1,0.5,1.1,1.1C31.1,20.8,30.6,21.3,30,21.3C30,21.3,30,21.3,30,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1263",
    className: "st1",
    d: "M30,25.6h-2.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0.1,0H30 c0.6,0,1.1,0.5,1.1,1.1C31.1,25.1,30.6,25.6,30,25.6C30,25.6,30,25.6,30,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1264",
    className: "st2",
    d: "M19.8,1.9c-0.2-0.2-0.6-0.3-0.9-0.2L1.5,5C0.9,5,0.6,5.5,0.6,6v24c0,0.5,0.4,1,0.9,1.1 l17.4,3.3c0.6,0.1,1.2-0.3,1.3-0.9c0-0.1,0-0.1,0-0.2V2.8C20.2,2.4,20,2.1,19.8,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1265",
    className: "st3",
    d: "M15.5,21.6l-3.4-3.9l3.5-4.5c0.4-0.5,0.3-1.2-0.2-1.5s-1.2-0.3-1.5,0.2L10.6,16l-2.7-3.1 c-0.4-0.5-1.1-0.5-1.5-0.2c-0.5,0.4-0.5,1.1-0.2,1.5c0,0,0,0,0.1,0.1l3,3.4l-3,3.9c-0.4,0.5-0.3,1.2,0.2,1.5 C6.9,23.6,7.6,23.5,8,23l2.8-3.6l3.2,3.6c0.4,0.5,1.1,0.5,1.5,0.2C15.9,22.8,16,22.2,15.5,21.6C15.6,21.7,15.6,21.7,15.5,21.6 L15.5,21.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExcel01);
export default __webpack_public_path__ + "static/media/ico-excel-01.921d56817e86d4e0b8ee0c66f41303b2.svg";
export { ForwardRef as ReactComponent };